import { ApiJsonClientError } from "@/lib/query/core/api-json-client";

// Backend error codes the J&T integration can surface, mapped to seller-safe
// copy (mirrors bostaErrors.ts — same rationale: never render raw backend
// phrasing).
export type JntErrorCode =
  | "JNT_DISABLED"
  | "JNT_CREDENTIALS_INVALID"
  | "JNT_UNREACHABLE"
  | "JNT_UNAVAILABLE";

const DEFAULT_MESSAGES: Readonly<Record<JntErrorCode, string>> = {
  JNT_DISABLED:
    "J&T integration is currently disabled on this platform. Contact support.",
  JNT_CREDENTIALS_INVALID:
    "J&T rejected this customer code / password pair. Double-check the values you received from your J&T branch.",
  JNT_UNREACHABLE: "Could not reach J&T. Please try again.",
  JNT_UNAVAILABLE:
    "J&T could not confirm these credentials right now. Please try again in a moment.",
};

export function resolveJntErrorMessage(error: unknown): {
  code: JntErrorCode | null;
  message: string;
} {
  if (error instanceof ApiJsonClientError) {
    const code = error.code as JntErrorCode | undefined;
    if (code && code in DEFAULT_MESSAGES) {
      return { code, message: DEFAULT_MESSAGES[code] };
    }
    if (error.message) {
      return { code: null, message: error.message };
    }
  }
  return {
    code: null,
    message:
      error instanceof Error ? error.message : "Something went wrong. Please try again.",
  };
}
